export const soundConnected = new Audio('./assets/sounds/connected.wav');
export const soundDisconnected = new Audio('./assets/sounds/disconnected.wav');
export const soundPeerJoined = new Audio('./assets/sounds/peer-joined.wav');
export const soundPeerLeft = new Audio('./assets/sounds/peer-left.wav');
export const soundChatMessage = new Audio('./assets/sounds/chat-message.wav');
export const soundPoked = new Audio('./assets/sounds/poked.wav');
// Recording start/stop (the transcription bot entering / leaving the room).
export const soundRecordingStarted = new Audio('./assets/sounds/recording-started.wav');
export const soundRecordingStopped = new Audio('./assets/sounds/recording-stopped.wav');
